import React from 'react';
import CloseIcon from '@atlaskit/icon/core/cross-circle';
import SearchIcon from '@atlaskit/icon/core/migration/search';
import LegacyCloseIcon from '@atlaskit/icon/glyph/cross-circle';
import { components } from '@atlaskit/select';
import { CloseIconWrapper, DisplayWrapper, DropdownIndicatorWrapper } from '../../../../common/ui/picker/styled';

// EM-2028 TODO: We are rendering both icons and hiding them via CSS display rule because
// the Popup component's ref is not correctly updated when this react-select component
// re-renders. i.e. it does not  update the refs when one of these components re-renders.
export var DropdownIndicator = function DropdownIndicator(props) {
  return /*#__PURE__*/React.createElement(components.DropdownIndicator, props, /*#__PURE__*/React.createElement(DropdownIndicatorWrapper, null, /*#__PURE__*/React.createElement(DisplayWrapper, {
    displayFlag: !!props.selectProps.inputValue
  }, /*#__PURE__*/React.createElement(CloseIconWrapper, {
    onClick: function onClick(event) {
      var _props$selectProps$on, _props$selectProps;
      event.preventDefault();
      (_props$selectProps$on = (_props$selectProps = props.selectProps).onInputChange) === null || _props$selectProps$on === void 0 || _props$selectProps$on.call(_props$selectProps, '', {
        action: 'input-change',
        prevInputValue: props.selectProps.inputValue
      });
    }
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    color: "currentColor",
    LEGACY_size: "small",
    label: "",
    LEGACY_fallbackIcon: LegacyCloseIcon,
    size: "small"
  }))), /*#__PURE__*/React.createElement(DisplayWrapper, {
    displayFlag: !props.selectProps.inputValue
  }, /*#__PURE__*/React.createElement(SearchIcon, {
    color: "currentColor",
    LEGACY_size: "small",
    label: ""
  }))));
};